import { usePreloadComponent } from '@ms/yammer-libs-lazy';
import { LazyRelayModuleWrapper } from '@ms/yammer-relay/dist/environment';
import React, { FC, useRef } from 'react';

import { enableGlobalCopilot, useGlobalCopilotStore } from '../../store';

import { LoadableGlobalCopilotDrawer, loadGlobalCopilotDrawer } from './LoadableGlobalCopilotDrawer';

enableGlobalCopilot();

interface DeferredGlobalCopilotDrawerProps {
  readonly isFeedbackEnabled: boolean;
}

export const DeferredGlobalCopilotDrawer: FC<DeferredGlobalCopilotDrawerProps> = ({ isFeedbackEnabled }) => {
  usePreloadComponent(loadGlobalCopilotDrawer);

  const { isOpen } = useGlobalCopilotStore();

  const hasLoaded = useRef(false);

  if (!hasLoaded.current && isOpen) {
    hasLoaded.current = true;
  }

  if (!hasLoaded.current) {
    return null;
  }

  return (
    <LazyRelayModuleWrapper>
      <LoadableGlobalCopilotDrawer isFeedbackEnabled={isFeedbackEnabled} />
    </LazyRelayModuleWrapper>
  );
};
